import { httpResource } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';

export interface AppInfoMessage {
  type: 'INFO' | 'WARNING' | 'ERROR';
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class AppInfoService {
  baseUrl: string = environment.api_url;

  readonly refreshTrigger = signal(0);

  messages = httpResource<AppInfoMessage[]>(() => {
    // Cette fonction est réactive : 
    // Si refreshTrigger change, la requête est re-exécutée.
    this.refreshTrigger();
    return `${this.baseUrl}/app-info`;
  });

    stats = httpResource<any[]>(() => {
    this.refreshTrigger();
    return `${this.baseUrl}/stats`;
  });

  constructor() {
    setInterval(() => {
      this.refreshTrigger.update(v => v + 1);
    }, 30_000); // poll every 30 seconds
  }

  refresh() {
    this.refreshTrigger.update(v => v + 1);
  }
}
